import { Box, Typography } from "@mui/material";

// svg
import { ReactComponent as IconAlert } from "../../assets/svg/alert-circle.svg";

export const AlertScreen = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          padding: "40px",
          boxShadow: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <IconAlert stroke="#ba1a1a" width={"32px"} height={"32px"} />
          <Typography textAlign={"center"} fontSize={"18px"} fontWeight={600}>
            Your session token has expired
          </Typography>
          <Typography textAlign={"center"} fontSize={"14px"} fontWeight={400}>
            Please refresh the page. If this keeps happening, contact support.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
